<template>
  <div class="main-container">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for='(item, index) in actArr' :key='index' @click='redirect(item)'>
            <img :src="item.actCoverUrl" alt="">
        </div>
      </div>
    </div>
    <div class='tips'>
        <p class='name'>主题博物馆</p>
        <p class='question'>想知道里面是什么嘛？</p>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';

export default {
    data() {
        return {
            actArr: [
                {
                    actCoverUrl: '/img/activeDeploy/act1.jpg',
                    redirectUrl: 'https://act.ywbjchina.com/theme-museum-paint/'
                },
                {
                    actCoverUrl: '/img/activeDeploy/act2.jpg',
                    redirectUrl: 'https://act.ywbjchina.com/museum'
                },
                {
                    actCoverUrl: '/img/activeDeploy/sachet.jpg',
                    redirectUrl: 'https://act.ywbjchina.com/theme-museum-sachet/'
                }
            ]
        };
    },
    mounted() {
        // eslint-disable-next-line no-unused-vars
        const swiper = new Swiper('.swiper-container', {
            autoplay: 500,
            slidesPerView: 'auto',
            spaceBetween: 40,
            centeredSlides: true,
            loop: true
        });
    },
    methods: {
        redirect(data) {
            window.location.href = data.redirectUrl;
        }
    }
};
</script>

<style lang='stylus' scoped>
@import '../../../node_modules/swiper/dist/css/swiper.min.css';
.swiper-container
    width 7.5rem
    height 90%
    overflow visible!important
    .swiper-wrapper
        display flex!important
        align-items center!important
        .swiper-slide
            width 5.44rem;
            height 100%;
            border-radius 20px
            display flex!important
            align-items center!important
            flex-direction column!important
            transition 300ms
            img
                width 100%
                height 100%
                border-radius 20px
            div
                .name
                    font-size 0.32rem
                    color rgb(51,51,51)
                .txt
                    font-size 0.24rem
                    color rgb(153,153,153)
        .swiper-slide-prev
            height 80%!important
        .swiper-slide-next
            height 80%!important
        .swiper-slide-active
            width 5.44rem
            height 90%!important
.tips
    width 100%
    height 10%
    display flex
    flex-direction column
    align-items center
    justify-content center
    .name
        font-size 0.4rem
        color #333333
    .question
        font-size 0.3rem
        color #999999
</style>
